function getProductMetafields(pid){
	return new Promise((resolve) => {
		const query =  `query getProductById($id: ID!) {
			product(id: $id) {
				title,
				metafields(identifiers: [ 
				{namespace: "product", key: "subtitle"}
				]) { 
				type 
				namespace 
				key 
				}
				variants(first: 50) {
					edges {
						node {
							id
							sku
							metafields(identifiers: [ 
							{namespace: "pre_order", key: "date"}
							
							]) {
							value
							type 
							namespace 
							key 
							}
						}
					}
				}
			}
		}`

		fetch('https://stylest.com/api/graphql', {
			method: "POST",
			headers: {
				"X-Shopify-Storefront-Access-Token":"29cb06d9d4d2298efaa098df451afec4",
			"Content-Type": "application/json",
				"Accept": "application/json"
			},
			body: JSON.stringify({ 
				query: query,
				variables: {
					id: `gid://shopify/Product/${pid}`,
				}
			})
		}).then(res => {
			return res.json();  
		}).then(data => {
			resolve(data)
		}).catch(err => {
			console.log(err)
		})
	});
}    

function getRebuyProductIds(){
	return new Promise((resolve) => {
		let rebuyWidgetProductIdArray = [];
		waitForRebuyWidget(() => {
			Array.from(document.getElementsByClassName('rebuy-widget-content')).forEach( widget => {
				Array.from(widget.getElementsByClassName('rebuy-product-block')).forEach( productBlock => {
					Array.from(productBlock.classList).forEach( className => {
						if(className.indexOf('product-id-') > -1){
							//console.log(className)
							rebuyWidgetProductIdArray.push(className.replace('product-id-',''))
						}
					})
				})
			})
			//console.log('rebuyWidgetProductIdArray')
			//console.log(rebuyWidgetProductIdArray)
			resolve(rebuyWidgetProductIdArray)
		})
	});

	function waitForRebuyWidget(callback) {
		if (window.location.pathname.includes('/products/')){
			let interval,
			counter = 0,
			duration = 250,
			limit = 80;
			interval = setInterval( () => {
				if (document.getElementsByClassName('rebuy-widget-content').length > 0){
					callback();
					clearInterval( interval );
				} else if ( counter === limit ) {
					clearInterval ( interval );
				} 
			}, duration );
		}
	}
}

function addLabels(n, data){
	//add pre-order info to select element options
	let optionsArr = Array.from(document.getElementsByClassName('rebuy-product-block')[n].getElementsByTagName('option'))
	optionsArr.forEach((opt, i) => {
		let variant = data.data.product.variants.edges.find(v => v.node.id.indexOf(opt.value) > -1);
		if(variant.node.metafields[0]){
			optionsArr[i].innerHTML = `${optionsArr[i].innerText} - Pre-order: ${variant.node.metafields[0].value}` 
		}
	})
}

function updateATC(n, data){
	let block = document.getElementsByClassName('rebuy-product-block')[n];
	let selectedValue = block.getElementsByTagName('select')[0].value;
	let variant = data.data.product.variants.edges.find(v => v.node.id.indexOf(selectedValue) > -1);
	let metafields = variant.node.metafields[0];
	if(metafields){
		block.getElementsByClassName('rebuy-button')[0].getElementsByTagName('span')[0].innerHTML = "PRE-ORDER"
	} else {
		block.getElementsByClassName('rebuy-button')[0].getElementsByTagName('span')[0].innerHTML = "Add to Cart"
	}
}

async function getRebuyProductData (){
  const productIdArr = await getRebuyProductIds();
	const data0 = await getProductMetafields(productIdArr[0]);
	const data1 = await getProductMetafields(productIdArr[1]);
	//console.log('data0')
	//console.log(data0)
	//console.log('data1')
	//console.log(data1)

	addLabels(0, data0);
	updateATC(0, data0);
	addLabels(1, data1);
	updateATC(1, data1);

	// update button on variant select change
	Array.from(document.getElementsByClassName('rebuy-product-block')).forEach( (block, i) => {
		block.getElementsByTagName('select')[0].addEventListener('change', e => {
			if(i === 0 ){
				updateATC(0, data0)
			}
			if(i === 1 ){
				updateATC(1, data1)
			}
		})
	})
}
getRebuyProductData ();